/**
 * Created by koppany.kiss on 2017. 11. 29..
 */

export default function (app) {
	app.directive('registrationNumber', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elm, attrs, ctrl) {
				var validate = function (viewValue) {
					if (viewValue) {
						if (viewValue.length > 0 || viewValue.length <= 8) {
							ctrl.$setValidity('registrationNumber', true);
						} else {
							ctrl.$setValidity('registrationNumber', false);
						}
					} else {
						ctrl.$setValidity('registrationNumber', true);
					}
					return viewValue;
				};
				ctrl.$parsers.unshift(validate);
				ctrl.$formatters.unshift(validate);
			}
		};
	});
};
